import MemberEventsLanding from './member-events-landing'

export default MemberEventsLanding
